export const grid = {
  columnCount: 12,
  gap: {
    min: 14,
    max: 24,
  },
}
